import {
  type ICalculatedData,
  useMarketCalculator,
} from "~/feature/event/providers/MarketCalculatorProvider";
import { type IMarket, MarketStatus } from "~/types/event";
import { getSettledElsewhereWarning } from "~/utils/resolution/settledElsewhereCopy";

export interface ITradeOnCard {
  market: IMarket;
  calculatedData: ICalculatedData;
  settledElsewhereWarning: string | null;
}

export const useTradeOnCards = (): ITradeOnCard[] => {
  const { market, calculatedData, groupedMarkets, calculatedGroupedData } =
    useMarketCalculator();

  if (!market) {
    return [];
  }

  const warning = getSettledElsewhereWarning([market, ...groupedMarkets]);

  const toCard = (
    cardMarket: IMarket,
    cardData: ICalculatedData
  ): ITradeOnCard => ({
    market: cardMarket,
    calculatedData: cardData,
    settledElsewhereWarning:
      cardMarket.unifiedStatus === MarketStatus.ACTIVE ? warning : null,
  });

  const otherPlatformCards = groupedMarkets
    .map((groupedMarket, index) =>
      toCard(groupedMarket, calculatedGroupedData[index])
    )
    .filter((card) => card.market.unifiedStatus === MarketStatus.ACTIVE);

  return [toCard(market, calculatedData), ...otherPlatformCards];
};
